<template>
  <div id="rates-create">
    <PmwTopProgress :start="loading" :done="!loading" color="#53B483" />

    <SidebarLayout3 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>
            Ações da página
          </Heading>

          <Button
            v-if="routeType"
            :disabled="disableSaveButton || loading"
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            class="page-actions--button"
            @click="createRate()"
          >
            Salvar
          </Button>
          <Button
            v-else
            :disabled="disableSaveButton || loading"
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            class="page-actions--button"
            @click="editRate()"
          >
            Salvar
          </Button>
          <Button
            layout="outline"
            class="page-actions--button"
            @click="$router.push({ name: 'AgrupadorTarifasListagem' })"
          >
            Voltar sem salvar
          </Button>
          <Button
            v-if="!routeType"
            variation="error"
            class="page-actions--button"
            @click.stop.prevent="deleteModal($route.params.id)"
          >
            Excluir
          </Button>
        </SidebarBlock>
      </template>

      <!-- FORMULÁRIO -->
      <template #content>
        <span class="form">
          <FormInput
            v-model="nome"
            :error="error.nome"
            :required="true"
            :showErrorFeedbackMessage="true"
            label="Nome do agrupador"
            placeholder="Insira o nome do agrupador"
            class="text-input--email large"
          />
        </span>

        <span class="form">
          <PmwSelectionBoxScroll
            v-model="selectedItems"
            :list="formatRateItems"
            :buffer="0"
            comparisonKey="codigo"
            placeholder="Busque pelo nome da tarifa"
            selectedPlaceholder="Busque pelo nome da tarifa selecionada"
            titleFirstBox="Adicionar tarifas do grupo"
            titleSecondBox="Tarifas selecionadas"
            class="scroll-container"
            @searchItem="searchedItem"
            @update="onUpdate"
          >
            <template #recycle-selection-box--empty-text-selection>
              <p v-if="!loadOptions" class="empty-text">
                Nenhuma tarifa selecionada para esse grupo de tarifas.<br />
              </p>
              <p v-else-if="loadOptions" class="pmw-loader"></p>
            </template>
          </PmwSelectionBoxScroll>

          <hr class="horizontal-line" />
        </span>

        <!-- FOOTER -->
        <span class="bottom-buttons">
          <Button
            layout="outline"
            class="bottom-buttons--return"
            @click="$router.push({ name: 'AgrupadorTarifasListagem' })"
          >
            Voltar sem salvar
          </Button>
          <Button
            v-if="routeType"
            :disabled="disableSaveButton || loading"
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            :popperStrategy="'auto'"
            class="bottom-buttons--save"
            @click="createRate()"
          >
            Salvar
          </Button>
          <Button
            v-else
            :disabled="disableSaveButton || loading"
            class="bottom-buttons--save"
            @click="editRate()"
          >
            Salvar
          </Button>
        </span>
      </template>
    </SidebarLayout3>

    <!-- MODAL DELEÇÃO -->
    <AlertModal
      v-model="showDeleteModal"
      :buttonClose="true"
      title="Excluir agrupador de tarifas"
      @alert-modal-cancel="cancelDisable()"
      @alert-modal-confirm="disableRate()"
    >
      <template #text>
        Ao excluir esse agrupador, não será mais possível visualizar as
        informações contidas nele de forma compilada em relatórios. <br />
        Tem certeza de que quer fazer isso?
      </template>
    </AlertModal>
  </div>
</template>

<script>
/** Componentes da lib */
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import { PmwSelectionBoxScroll } from '@solucoes/components-lib-tmp/src/components/patterns/PmwSelectionBox'
import PmwTopProgress from '@solucoes/components-lib-tmp/src/components/elements/PmwTopProgress'

/** Imports do projeto */
import SidebarLayout3 from '@/layouts/SidebarLayout3'

export default {
  name: 'rateBundlerCreate',
  components: {
    Button,
    FormInput,
    Heading,
    SidebarLayout3,
    AlertModal,
    SidebarBlock,
    PmwSelectionBoxScroll,
    PmwTopProgress
  },
  data() {
    return {
      options: [] /** Opções de tarifas */,
      selectedItems: [] /** Array de itens selecionados */,
      nome: '' /** Nome do grupo */,
      breadcrumb: [
        {
          label: 'Configurações',
          url: '/',
          isSpa: true
        },
        {
          label: 'Agrupador de tarifas',
          url: '/Admin/v2/agrupador-tarifas'
        },
        {
          label: 'Criar novo agrupador de tarifas'
        }
      ],
      /** Guarda tipo de página (Edição/Criação)  */
      routeType: '',
      /** Título da página  */
      pageTitle: null,
      /** Exibição da modal de deleção */
      showDeleteModal: false,
      /** Guarda Id para deleção */
      rateDelete: null,
      /** Guarda Id da tarifa */
      rateId: null,
      /** Controle de erro */
      error: {
        nome: false
      },
      firstLevelList: null,
      childValue: null,

      rateItems: [],
      searchText: null,
      updateParts: {
        viewStartIdx: 0,
        viewEndIdx: 0,
        visibleStartIdx: 0,
        visibleEndIdx: 0
      },
      isSearch: false,
      currentPage: null,
      loadOptions: false,
      loading: false,

      stopPagination: false
    }
  },
  computed: {
    formatRateItems() {
      return this.rateItems.reduce((accumulador, currentValue) => {
        accumulador.push({
          label: currentValue.nome,
          codigo: currentValue.codigo
        })

        currentValue.tarifas.forEach((item) => {
          item.nome = item.descricao
        })

        accumulador = [...accumulador, ...currentValue.tarifas]

        return accumulador
      }, [])
    },

    disableSaveButton() {
      if (
        this.nome !== '' &&
        this.selectedItems.length !== 0 &&
        !this.loading
      ) {
        return false
      }
      return true
    }
  },
  watch: {
    /** Controle de erro de nome */
    nome: {
      handler: function() {
        if (this.nome !== '') {
          this.error.nome = false
        } else {
          this.error.nome = true
        }
      },
      deep: true
    }
  },

  created() {
    /** Get de métodos */
    this.pageType()
    this.getRates()
  },

  methods: {
    /** Faz o filtro dos itens via back
     * @param {String} $event - Texto pesquisado
     */
    searchedItem($event) {
      $event ? (this.isSearch = true) : (this.isSearch = false)
      this.loadOptions = true
      this.rateItems = []
      this.searchText = $event
      this.stopPagination = false
      this.getRates(1, $event)
    },

    /** Atualiza valores dos itens carregados e dos exibidos para o usuário
     * @param {Number} $viewStartIndex - Valor inicial carregado
     * @param {Number} $viewEndIndex - Valor final carregado
     * @param {Number} $visibleStartIndex - Valor inicial visível
     * @param {Number} $visibleEndIndex - Valor final visível
     */
    onUpdate(viewStartIndex, viewEndIndex, visibleStartIndex, visibleEndIndex) {
      this.updateParts.viewStartIdx = viewStartIndex
      this.updateParts.viewEndIdx = viewEndIndex
      this.updateParts.visibleStartIdx = visibleStartIndex
      this.updateParts.visibleEndIdx = visibleEndIndex

      if (
        this.formatRateItems.length - this.updateParts.viewStartIdx < 10 &&
        !this.loadOptions
      ) {
        this.loadOptions = true
        this.getRates(+this.currentPage + 1, this.searchText)
      }
    },

    fillEditionFields(response) {
      for (let i = 0; i < this.ratesSelectOptions.length; i++) {
        const options = []
        for (let j = 0; j < this.ratesSelectOptions[i].options.length; j++) {
          /**
            Validar se a tarifa deve ser removida da listagem
            Se a opção possuir status desativado e o cupom não possuir essa tarifa vinculada
          */
          if (
            this.ratesSelectOptions[i].options[j].ativo ||
            response.data.tarifas.includes(
              this.ratesSelectOptions[i].options[j].value
            )
          ) {
            options.push(this.ratesSelectOptions[i].options[j])
          }
        }
        this.ratesSelectOptions[i].options = options
      }
      /** Seta o tipo de desconto  */
      this.fields.tipoValor = this.discountTypeSelectOptions.find(
        (item) => item.value === this.fields.tipoValor
      )

      /** seta as tarifas selecionadas  */
      this.fields.tarifas = this.ratesSelectOptions.reduce((acc, curr) => {
        const found = curr.options.filter((item) =>
          this.fields.tarifas.includes(item.value)
        )

        if (found) acc = [...acc, ...found]

        return acc
      }, [])

      const activeRates = response.data.tarifas.filter((item) => {
        return this.ratesSelectOptions
          .flatMap((item) => item.options)
          .some((rate) => item.value === rate.value)
      })

      if (activeRates.length !== response.data.tarifas.length) {
        this.rateStatus = true
      }
    },

    /** Verifica se é edição ou criação */
    pageType() {
      if (this.$route.name === 'AgrupadorTarifasCriar') {
        this.routeType = true
        this.pageTitle = 'Criar novo agrupador de tarifas'
      } else {
        this.routeType = false
        this.getSingleRate()
      }
    },

    /** verificar se dado existe */
    ifExists(element) {
      /** se for array */
      let result = null
      if (element && typeof element.value !== 'undefined') {
        result = element.value
        /** se for string */
      } else if (element !== '') {
        result = element
      }
      return result === true ? 1 : result
    },

    /** Retorna dados do usuário */
    getSingleRate() {
      this.$rate.get(this.$route.params.id).then((response) => {
        /** Temporário */
        this.nome = response.data.nome
        const returnData = response.data.tarifas

        returnData.forEach((dados) => {
          const data = {
            codigo: dados.codigo,
            descricao: dados.codigo + ' - ' + dados.nome.trim(),
            ativo: true,
            text: dados.codigo + ' - ' + dados.nome.trim(),
            id: dados.codigo
          }

          this.selectedItems.push(data)
        })

        this.breadcrumb = [
          {
            label: 'Configurações'
          },
          {
            label: 'Agrupador de tarifas',
            url: '/Admin/v2/agrupador-tarifas'
          },
          {
            label: `Editando ${this.nome}`
          }
        ]
        this.pageTitle = 'Editando ' + this.nome
      })
    },

    /** Edição de usuário */
    editRate() {
      if (this.nome === null && !this.selectedItems.length) {
        return this.$bus.$emit('show-alert-chip', {
          message: 'Por favor, preencha todos os campos obrigatórios'
        })
      }

      const tarifasIDs = this.selectedItems.map((item) => {
        return parseInt(item.codigo)
      })

      this.$rate
        .editRate({
          nome: this.nome,
          tarifas: tarifasIDs,
          codigo: parseInt(this.$route.params.id)
        })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de tarifas editado com sucesso'
          })
          this.$router.push({ name: 'AgrupadorTarifasListagem' })
        })
        .catch((err) => {
          this.$bus.$emit('show-alert-chip', {
            message: err.messages[0]
          })
        })
    },

    /** Cria uma nova receita */
    createRate() {
      if (this.nome === null && !this.selectedItems.length) {
        return this.$bus.$emit('show-alert-chip', {
          message: 'Por favor, preencha todos os campos obrigatórios'
        })
      }

      /** Tratamendo de dados para envio de Grupos */
      const tarifasIDs = this.selectedItems.map((item) => {
        return parseInt(item.codigo)
      })

      this.$rate
        .createRate({
          nome: this.nome,
          tarifas: tarifasIDs
        })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de tarifas criado com sucesso'
          })
          this.$router.push({ name: 'AgrupadorTarifasListagem' })
        })
        .catch((err) => {
          this.$bus.$emit('show-alert-chip', {
            message: err.messages[0]
          })
        })
    },

    /** Chamada para deletar usuário */
    disableRate() {
      this.$rate
        .disableRate({ agrupadores: [parseInt(this.$route.params.id)] })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de tarifas excluido com sucesso'
          })
          this.$router.push({ name: 'AgrupadorTarifasListagem' })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar agrupador de tarifas'
          })
        })
    },

    /** Retorna dados do usuário */
    /** Retorna dados do usuário
     * @param {Number} page - Número da página do filtro
     * @param {Number} name - Nome da tarifa a ser pesquisada da página do filtro
     * @param {Number} pageSize - Tamanho da página a ser pesquisada no filtro
     */
    async getRates(page = 1, name = null, pageSize = 2) {
      if (this.stopPagination) {
        this.loadOptions = false
        this.loading = false
        return
      }

      this.currentPage = +page

      this.loading = true
      await this.$rate
        .getFluctuationRates({
          tamanhoPagina: pageSize,
          pagina: page,
          nome: name ? name : null
        })
        .then(async (response) => {
          if (!response.data.itens.length) this.stopPagination = true

          await response.data?.itens?.forEach((item) => {
            const itemExists = this.rateItems.find(
              (existingItem) => existingItem.codigo === item.codigo
            )

            if (!itemExists) {
              this.rateItems.push(item)
            }
          })
        })
        .finally(() => {
          this.loading = false
          this.loadOptions = false
        })
    },

    /** Controle de deleção */
    deleteModal(rateId) {
      this.showDeleteModal = true
      this.rateDelete = rateId
    },

    /** Controle de cancelamento de deleção */
    cancelDisable() {
      this.showDeleteModal = false
      this.rateDelete = null
    }
  }
}
</script>

<style lang="scss" scoped>
.pmw-loader {
  @include pmw-loader();
}

.large {
  width: 270px;
}
.medium {
  width: 150px;
}
.small {
  width: 56px;
}

.horizontal-line {
  margin: 0 auto 10px;
}

.text-input {
  &--email {
    margin-top: 37px;
    margin-right: 35px;
  }
  &--limit {
    width: 141px;
  }
}

.form {
  display: block;
  gap: 20px;
  margin-bottom: 30px;
}

.bottom-buttons {
  display: flex;
  justify-content: space-between;
  &--return,
  &--save {
    z-index: 2;
    width: 215px;
  }
}

::v-deep .lb-breadcrumb--link:nth-child(2) {
  pointer-events: none;
}

::v-deep .content--white_card {
  padding: {
    top: 20px;
  }
}

.page-actions {
  padding-top: 50px;
  &--button {
    width: 100%;
    cursor: pointer;

    & + .page-actions--button {
      margin-top: 10px;
    }
  }
}
</style>
